import React from "react";
import './AutoSuggest.scss'
import { isEmpty } from "../../utils/common";


const AutoSuggestion = ({
  cityName,
  setCityName,
  setCityId,
  fromCityList = [],
  setShowCity,
  showCity,
  cityNameKey = "",
  className = "",
  inputElement,
  onChange=()=>{},
  randerItem
}) => {


  const handleScroll = () => {
    inputElement?.blur();
  };
 
  
  const handleCityClick = (location) => {
    const { name, city, country, id, code } = location;

    // Update selected city and ID
    setCityId(code || id);
    setCityName(name); 
     
    onChange(location)
    setShowCity(false);
  };

  return (
    <div onScroll={handleScroll} className={`cityName ${className}`}>
      <ul>
        {!isEmpty(fromCityList) && fromCityList?.map((location, index) => {
        
            return(
               <>
               {
                randerItem?randerItem?.(location,index)
                :
                  <li key={index} onClick={() => handleCityClick(location)}>
                <div className="flex justify-between pd-10-0">
                  <div className="flex gap-15 items-center">
                   
                    <div className="flex column gap-5">
                      <span className="fs-13 fw-500 cursor">{location?.name}</span>
                      <label className="fs-10 fw-400 cursor color_grey">
                        {`${location?.city == null ? "":location?.city}  ${location?.country ==null ?"" :location?.country}`}
                      </label>
                    </div>
                  </div>
                  <div className="flex gap-10 items-center cursor">
                    <span className="fs-12 fw-600">{location?.code}</span>
                  </div>
                </div>
              </li>
               }
               
               </>
              
            )
        }
         
        )}
        {
          isEmpty(fromCityList) &&  <div className="flex justify-between text-center pd-10-0">
          <div className="flex gap-15 items-center">
           
            <div className="flex column gap-5 " style={{paddingLeft:"10px"}}>
         
              <label className="fs-10 fw-400 cursor color_grey">
                 No record found
              </label>
            </div>
          </div>
         
        </div>
        }
      </ul>
    </div>
  );
};

export default AutoSuggestion;
